import de from './de.translations.json.js';
import en from './en.translations.json.js';
import es from './es.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import nl from './nl.translations.json.js';
import { uiPaginationTranslationsDe, uiPaginationTranslationsEn, uiPaginationTranslationsEs, uiPaginationTranslationsFr, uiPaginationTranslationsIt, uiPaginationTranslationsNl } from '../ui-pagination/index.js';
import localizationSupportTranslationsEn from '../../mixins/localization-support/en.translations.json.js';
import localizationSupportTranslationsDe from '../../mixins/localization-support/de.translations.json.js';
import localizationSupportTranslationsFr from '../../mixins/localization-support/fr.translations.json.js';
import localizationSupportTranslationsIt from '../../mixins/localization-support/it.translations.json.js';
import localizationSupportTranslationsEs from '../../mixins/localization-support/es.translations.json.js';
import localizationSupportTranslationsNl from '../../mixins/localization-support/nl.translations.json.js';

const portfolioPositionsTopFlopTranslationsDe = { ...de, ...localizationSupportTranslationsDe, ...uiPaginationTranslationsDe };
const portfolioPositionsTopFlopTranslationsEn = { ...en, ...localizationSupportTranslationsEn, ...uiPaginationTranslationsEn };
const portfolioPositionsTopFlopTranslationsEs = { ...es, ...localizationSupportTranslationsEs, ...uiPaginationTranslationsEs };
const portfolioPositionsTopFlopTranslationsFr = { ...fr, ...localizationSupportTranslationsFr, ...uiPaginationTranslationsFr };
const portfolioPositionsTopFlopTranslationsIt = { ...it, ...localizationSupportTranslationsIt, ...uiPaginationTranslationsIt };
const portfolioPositionsTopFlopTranslationsNl = { ...nl, ...localizationSupportTranslationsNl, ...uiPaginationTranslationsNl };
const portfolioPositionsTopFlopTranslationsBundle = {
  de: portfolioPositionsTopFlopTranslationsDe,
  en: portfolioPositionsTopFlopTranslationsEn,
  es: portfolioPositionsTopFlopTranslationsEs,
  fr: portfolioPositionsTopFlopTranslationsFr,
  it: portfolioPositionsTopFlopTranslationsIt,
  nl: portfolioPositionsTopFlopTranslationsNl
};

export { portfolioPositionsTopFlopTranslationsBundle, portfolioPositionsTopFlopTranslationsDe, portfolioPositionsTopFlopTranslationsEn, portfolioPositionsTopFlopTranslationsEs, portfolioPositionsTopFlopTranslationsFr, portfolioPositionsTopFlopTranslationsIt, portfolioPositionsTopFlopTranslationsNl };
